import React from "react";

interface GoalSkeletonProps {
  count?: number;
}

const GoalSkeleton: React.FC<GoalSkeletonProps> = ({ count = 1 }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className="animate-pulse">
          <div className="p-[32px]">
            {/* Goal title */}
            <div className="h-6 bg-gray-200 rounded w-3/4 mb-4"></div>

            {/* Progress percentage */}
            <div className="h-8 bg-gray-200 rounded w-16 mb-2"></div>

            {/* Progress bar */}
            <div className="w-full bg-gray-200 rounded-full h-2 mb-4"></div>

            {/* Goal details */}
            <div className="mt-4 space-y-2">
              <div className="flex justify-between">
                <div className="h-4 bg-gray-200 rounded w-20"></div>
                <div className="h-4 bg-gray-200 rounded w-32"></div>
              </div>
              <div className="flex justify-between">
                <div className="h-4 bg-gray-200 rounded w-16"></div>
                <div className="h-4 bg-gray-200 rounded w-12"></div>
              </div>
              <div className="flex justify-between">
                <div className="h-4 bg-gray-200 rounded w-14"></div>
                <div className="h-4 bg-gray-200 rounded w-20"></div>
              </div>
              <div className="flex justify-between">
                <div className="h-4 bg-gray-200 rounded w-16"></div>
                <div className="h-4 bg-gray-200 rounded w-24"></div>
              </div>
            </div>
          </div>
          {index < count - 1 && <hr />}
        </div>
      ))}
    </>
  );
};

export default GoalSkeleton;
